import { render, staticRenderFns } from "./MarketReports.vue?vue&type=template&id=0ad4aa8e&scoped=true&"
import script from "./MarketReports.vue?vue&type=script&lang=js&"
export * from "./MarketReports.vue?vue&type=script&lang=js&"
import style0 from "./MarketReports.vue?vue&type=style&index=0&id=0ad4aa8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4aa8e",
  null
  
)

export default component.exports